<!--
 * @Description: 值班日志详情
 * @Author: PF
 * @Date: 2023-09-01 10:00:43
 * @LastEditors: PF
 * @LastEditTime: 2024-02-04 10:04:25
-->
<template>
  <div>
    <el-dialog class="w900 h700" :model-value="openZhiBanRiZhi" :close-on-click-modal="false" :show-close="false"
      destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">值班日志详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openZhiBanRiZhi', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="值班人员" label-align="right" align="left" width="140px" span="2">{{ruleForm.zbryxm}}</el-descriptions-item>
        <el-descriptions-item label="手机号码" label-align="right" align="left" width="130px" span="2">{{ruleForm.yddh}}</el-descriptions-item>
        <el-descriptions-item label="值班类别 " label-align="right" align="left" span="2">{{ruleForm.zblbmc}}</el-descriptions-item>
        <el-descriptions-item label="值班日期" label-align="right" align="left" span="2">{{ruleForm.zbrq}}</el-descriptions-item>
        <el-descriptions-item label="值班内容名称" label-align="right" align="left" span="2">{{ruleForm.zbnrmc}}</el-descriptions-item>
        <el-descriptions-item label="值班时间" label-align="right" align="left" span="2">
          {{ ruleForm.zbkssj }}<span v-if="ruleForm.zbkssj && ruleForm.zbjssj" class="ml5 mr5">-</span>{{ ruleForm.zbjssj }}
        </el-descriptions-item>
        <el-descriptions-item label="接班人" label-align="right" align="left" span="2">{{ruleForm.jbrys}}</el-descriptions-item>
        <el-descriptions-item label="值班状况" label-align="right" align="left" span="2">
          <span v-for="(item, index) in zbzkData" :key="index">
            <span v-if="item.value==ruleForm.zbzk">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="存在问题" label-align="right" align="left" span="4">{{ruleForm.czwt}}</el-descriptions-item>
        <el-descriptions-item label="处理结果" label-align="right" align="left" span="4">{{ruleForm.cljg}}</el-descriptions-item>
      </el-descriptions>
      <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#CCCCCC">
        <tr v-for="(item,index) in ruleForm.zblbrzmbs" :key="index">
          <td bgcolor="#f4f4f5" class="pl10 pr10" style="text-align: right;width: 20%;">{{item.mbmc}}</td>
          <td style="text-align: left;">
            <el-input v-if="zbrzmblxData.wb === item.lx" v-model="item.nr" placeholder="请输入" />
            <span class="ml10 mr10" v-if="zbrzmblxData.dx === item.lx" style="display: flex;flex-direction: column;">
              <el-radio v-for="(val,v) in item.xztxxs" :key="v"  v-model="val.sfmrz" :label="true" @click="sfmrzClick(index,v)">{{ val.xxnr }}</el-radio>
            </span>
            <span class="ml10 mr10" v-if="zbrzmblxData.dxs === item.lx" style="display: flex;flex-direction: column;">
              <el-checkbox v-for="(val,v) in item.xztxxs" :key="v"  v-model="val.sfmrz" :label="false">{{ val.xxnr }}</el-checkbox>
            </span>
          </td>
        </tr>
      </table>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openZhiBanRiZhi', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>

</template>
<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadSelect, actionPost } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({ openZhiBanRiZhi: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openZhiBanRiZhi', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const jbrData = ref([])
const zbzkData = ref([])
const zbrzmblxData = ref({ listZhuangTai: [] })

watch(
  () => props.openZhiBanRiZhi,
  () => {
    if (props.openZhiBanRiZhi) {
      const o = { url: '/api/v2/bangong/zhibanrenyuanrizhijilu/' + props.row.dbgzid, data: {} }
      actionPost(o).then((res) => {
        if (res.code === 200) {
          ruleForm.value = res.data
          loadSelect({ url: '/api/v2/bangong/zhibanrizhimuban/zhibanrizhileixing', data: zbrzmblxData })
          loadSelect({ url: '/api/v2/bangong/zhibanrenyuanjilu/jiebanren', data: jbrData, parms: { zbrwid: res.data.zbrwid, zbrq: res.data.zbrq } })
          loadSelect({
            url: '/api/v2/bangong/zhibanrenyuanrizhijilu/zhibanzhuangkuang',
            data: zbzkData,
            loadSuccess: function (res) {
              ruleForm.value.zbzk = res.data[0].value
            }
          })
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

</script>

<style lang="less" scoped>
.el-checkbox {
  margin-right: 0;
}
:deep(.el-radio__label), :deep(.el-checkbox__label) {
  width: 100% !important;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;
  padding-left: 0;
  margin-left: 5px;
  margin-right: -5px;
}
</style>
